import { inject } from '@angular/core';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import {
  ICompleteOnboardingDto,
  IOnboardingStatus,
  ONBOARDING_STATUS_SCHEMA,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../../app-config.service';
import { IGetGateway, ISaveGateway } from '../../gateways';

export class OnboardingGateway
  implements
    IGetGateway<never, IApiResponse<IOnboardingStatus>>,
    ISaveGateway<ICompleteOnboardingDto, IApiResponse<IOnboardingStatus>>
{
  private readonly configService: AppConfigService = inject(AppConfigService);

  private readonly getRestCallBuilder: RestCallBuilder<
    never,
    IOnboardingStatus
  > = new RestCallBuilder<never, IOnboardingStatus>({ completed: false });

  private readonly saveRestCallBuilder: RestCallBuilder<
    ICompleteOnboardingDto,
    IOnboardingStatus
  > = new RestCallBuilder<ICompleteOnboardingDto, IOnboardingStatus>({
    completed: false,
  });

  get(): Observable<IApiResponse<IOnboardingStatus>> {
    return this.getRestCallBuilder
      .getExternal(
        `${this.configService.get().general.userServiceUrl}/user/onboarding`
      )
      .validate(API_RESPONSE_SCHEMA(ONBOARDING_STATUS_SCHEMA), 'Onboarding.get')
      .handleMessages()
      .build();
  }

  save(
    query: ICompleteOnboardingDto
  ): Observable<IApiResponse<IOnboardingStatus>> {
    return this.saveRestCallBuilder
      .postExternal(
        `${this.configService.get().general.userServiceUrl}/user/onboarding`,
        query
      )
      .validate(
        API_RESPONSE_SCHEMA(ONBOARDING_STATUS_SCHEMA),
        'Onboarding.save'
      )
      .handleMessages()
      .build();
  }
}
